import { render } from "./ClientProgressReport.vue?vue&type=template&id=8e2b82d8"
import script from "./ClientProgressReport.vue?vue&type=script&lang=js"
export * from "./ClientProgressReport.vue?vue&type=script&lang=js"

import "./ClientProgressReport.vue?vue&type=style&index=0&id=8e2b82d8&lang=css"

import exportComponent from "/home/forge/backalleyfitness.ponoapp.com/releases/82036017/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__